<template>
    <div class="inner FriendshiplinksList">
        <div class="title">友情链接</div>
        <div class="FriendshiplinksBox">
            <div v-for="(v, i) of List" :key="i">
                <div v-if="v">
                    <img :src="v.imgUrl" alt="">
                    <span>{{v.title}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        List: Array
    }
}
</script>

<style>
    .FriendshiplinksBox {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
        border: 0.01rem solid #0e5298;
        background: rgba(14, 82, 152, .2);
    }
    .FriendshiplinksBox > div {
        width: calc(100% / 3);
        font-size: 0.2rem;
        height: 1rem;
        padding: 0.3rem 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .FriendshiplinksBox > div > div {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
    }
    .FriendshiplinksBox > div > div > img {
        width: 20%;
        height: 0.36rem;
        background: #ccc;
        margin-right: 5%;
    }
    .FriendshiplinksBox > div > div > span {
        width: 75%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>


// WEBPACK FOOTER //
// src/components/ivew/friendshiplinksModel.vue